/**
 * The `/newsletters/$issueNumber` route param, as a number — or `null` when
 * it is not one.
 *
 * The route key is the INTEGER issue number, never the slug
 * (`schemas/newsletter.ts`: "slug is a decoy"). A param that is not a
 * positive integer cannot name an issue, so it resolves to a not-found
 * screen WITHOUT a request: `Number('abc')` is `NaN`, and
 * `/api/v5/newsletters/NaN/` is a guaranteed 404 that costs a round trip to
 * learn nothing. `Number.parseInt` is avoided on purpose — it would read
 * "20abc" as 20 and happily fetch a real issue for a URL that does not name
 * it.
 *
 * Its own `lib/` module, not `NewsletterIssueScreen.tsx`, because
 * `NewsletterIssueScreen.loader.ts` needs it to skip the request too, and a
 * route loader must not import a component module (loaders are not
 * code-split — see that loader's own doc). The screen imports it from here.
 */
export const parseIssueNumber = (raw: string): number | null => {
  if (!/^\d+$/.test(raw)) return null
  const value = Number(raw)
  return Number.isSafeInteger(value) && value > 0 ? value : null
}
